<div *ngIf="!isMobile">
  <div class="filter-container">
    <h5>Por categoría <span *ngIf="selectedCategoriesCount > 0">({{ selectedCategoriesCount }})</span></h5>
    <div *ngFor="let cat of categs" [formGroup]="categoriesTag">
      <div class="form-check">
        <input (change)="addCategories($event)" [formControlName]="cat.label" value="" class="form-check-input" type="checkbox" id="{{ cat.label }}">
        <label class="form-check-label" for="{{ cat.label }}">
          {{ cat.label }}
        </label>
      </div>
    </div>
  </div>
  <div class="filter-container">
    <h5>Módo de uso<span *ngIf="selectedModoDeUsoCount > 0">({{ selectedModoDeUsoCount }})</span></h5>
    <div *ngFor="let mdu of modoDeUso" [formGroup]="modoDeUsoTag">
      <div class="form-check">
        <input (change)="addModoUso($event)" [formControlName]="mdu.label" class="form-check-input" type="checkbox"
          value="" id="{{mdu.label}}">
        <label class="form-check-label" for="{{mdu.label}}">
          {{ mdu.label }} {{mdu.lenght}}
        </label>
      </div>
    </div>
  </div> 
  <div class="filter-container">
    <h5>Días de validez<span *ngIf="selectedDaysCount > 0">({{ selectedDaysCount }})</span></h5>
    <div class="section-days" [formGroup]="diasTag">
      <div *ngFor="let dia of filteredDias">
        <div class="form-check">
          <input 
            (change)="addDays($event, dia.label)" 
            [formControlName]="dia.label"
            class="input-days form-check-input" 
            type="checkbox" 
            [id]="dia.label"
          >
          <label class="form-check-label days" [ngStyle]="{'background-color': diasTag.get(dia.label)?.value ? '#FBCE07' : '#fff', 'color': diasTag.get(dia.label)?.value ? '#FBCE07' : '#000'}"  [for]="dia.label" >
            <span class="day-initial">
              {{ dia.label.charAt(0) }}
            </span>
          </label>
        </div>  
      </div>
    </div>
    <div class="form-check">
      <input 
        formControlName="Todos los días" 
        class="form-check-input" 
        type="checkbox"
        id="todos-los-dias"
        (change)="toggleTodosLosDias($event)"
        [checked]="diasTag.get('Todos los días')?.value"
      >
      <label class="form-check-label" for="todos-los-dias">
        Todos los días
      </label>
    </div>
  </div>
  
  <div class="filter-container">
    <h5>Por beneficio<span *ngIf="selectedBeneficiosCount > 0">({{ selectedBeneficiosCount }})</span></h5>
    <div *ngFor="let ben of beneficios" [formGroup]="beneficiosTag">
      <div class="form-check">
        <input [formControlName]="ben.label" (change)="addBeneficios($event)"class="form-check-input" type="checkbox"
          value="" id="{{ben.label}}">
        <label class="form-check-label" for="{{ben.label}}">
          {{ ben.label  }}
        </label>
      </div>
    </div>
  </div>  
</div>
<div class="mobile-filter-container" *ngIf="isMobile">
  <div class="mobile-filters">
    <!-- <img src="../../../assets/icon/icon-line-mobile.svg" alt=""> -->
    <img src="../../../assets/icon/icon-close-grey.svg" alt="Cerrar menú" (click)="toggleMenu()">
    <h2>Filtros</h2>
    <img src="" alt="">
    <div class="side-options">
      <span>Ordenar por</span>
      <select (change)="selectOrder($event)" class="order-options">
        <option *ngFor="let option of orders" value={{option.id}}> {{option.label}} </option>
      </select>
    </div>
    <div>
      <div class="filter-description">
        <div class="category-toggle">
          <div class="category-title">
            <h5 (click)="toggleCategory('categorias')">
              Categorías 
              <span *ngIf="selectedCategoriesCount > 0">({{ selectedCategoriesCount }})</span>
            </h5>  
          </div>
          <img [src]="expandedCategory === 'categorias' ? '../../../assets/icon/icon-close-menu-mobile.svg' : '../../../assets/icon/icon-open-menu-mobile.svg'" alt="menu icon"  class="open-items" (click)="toggleCategory('beneficios')"/>
        </div>      
        <div class="option-filter" *ngIf="expandedCategory === 'categorias'">
          <div *ngFor="let cat of categs" [formGroup]="categoriesTag">
            <div class="form-check">
              <input (change)="addCategories($event)" formControlName="{{ cat.label }}" class="form-check-input" type="checkbox" id="{{ cat.label }}">
              <label class="form-check-label" for="{{ cat.label }}">
                {{ cat.label }}
              </label>
            </div>
          </div>
        </div>
      </div>
      <div class="filter-description">
        <div class="category-toggle">
          <div class="category-title">
            <h5 (click)="toggleCategory('modoDeUso')">
              Modo de uso <span *ngIf="selectedModoDeUsoCount > 0">({{ selectedModoDeUsoCount }})</span>
            </h5>  
          </div>
          <img [src]="expandedCategory === 'modoDeUso' ? '../../../assets/icon/icon-close-menu-mobile.svg' : '../../../assets/icon/icon-open-menu-mobile.svg'" alt="menu icon"  class="open-items" (click)="toggleCategory('beneficios')"/>
        </div>             
        <div class="option-filter" *ngIf="expandedCategory === 'modoDeUso'">
          <div *ngFor="let mdu of modoDeUso" [formGroup]="modoDeUsoTag">
            <div class="form-check">
              <input (change)="addModoUso($event)" [formControlName]="mdu.label" class="form-check-input" type="checkbox" value="" id="{{mdu.label}}">
              <label class="form-check-label" for="{{mdu.label}}">
                {{ mdu.label }} {{mdu.lenght}}
              </label>
            </div>
          </div>
        </div>
      </div>
      <div class="filter-description">
        <div class="category-toggle">
          <div class="category-title">
            <h5 (click)="toggleCategory('diasDeValidez')">Días de validez
              <span *ngIf="selectedDaysCount > 0">({{ selectedDaysCount }})</span>
            </h5>
          </div>
          <img [src]="expandedCategory === 'diasDeValidez' ? '../../../assets/icon/icon-close-menu-mobile.svg' : '../../../assets/icon/icon-open-menu-mobile.svg'" alt="menu icon"  class="open-items" (click)="toggleCategory('beneficios')"/>
        </div>   
        <form [formGroup]="diasTag">
          <div class="day-filter" *ngIf="expandedCategory === 'diasDeValidez'">
            <div class="section-days" [formGroup]="diasTag">
              <div *ngFor="let dia of filteredDias">
                <div class="form-check">
                  <input 
                    (change)="addDays($event, dia.label)" 
                    [formControlName]="dia.label"
                    class="form-check-input input-days" 
                    type="checkbox" 
                    [id]="dia.label"
                  >
                  <label class="form-check-label days" for="{{ dia.label }}" [ngStyle]="{'background-color': diasTag.get(dia.label)?.value ? '#FBCE07' : '#fff', 'color': diasTag.get(dia.label)?.value ? '#FBCE07' : '#000'}"  [for]="dia.label" >
                    <span class="day-initial">
                      {{ dia.label.charAt(0) }}
                    </span>
                  </label>
                </div>              
              </div>
            </div>
          </div>
        </form>                   
        <div class="form-check" *ngIf="expandedCategory === 'diasDeValidez'">
          <input 
            formControlName="Todos los días" 
            class="input-day" 
            type="checkbox"
            id="todos-los-dias"
            (click)="toggleTodosLosDias($event)"
            [checked]="diasTag.get('Todos los días')?.value"         
          >
          <label class="form-check-label" for="todos-los-dias">
            Todos los días
          </label>
        </div> 
      </div>
      <div class="filter-description">
        <div class="category-toggle">
          <div class="category-title">
            <h5 (click)="toggleCategory('beneficios')">
              Por beneficio <span *ngIf="selectedBeneficiosCount > 0">({{ selectedBeneficiosCount }})</span>
            </h5>
          </div>
          <img [src]="expandedCategory === 'beneficios' ? '../../../assets/icon/icon-close-menu-mobile.svg' : '../../../assets/icon/icon-open-menu-mobile.svg'" alt="menu icon"  class="open-items" (click)="toggleCategory('beneficios')"/>
        </div>   
        <div class="option-filter" *ngIf="expandedCategory === 'beneficios'">
          <div *ngFor="let ben of beneficios" [formGroup]="beneficiosTag">
            <div class="form-check">
              <input [formControlName]="ben.label" (change)="addBeneficios($event)" class="form-check-input" type="checkbox" value="" id="{{ben.label}}">
              <label class="form-check-label" for="{{ben.label}}">
                {{ ben.label }}
              </label>
            </div>
          </div>
        </div>
      </div>
    </div>
    <a class="clean-filters" (click)="clearFilters()">Borrar Filtros</a>
    <a class="show-filters" (click)="applyFilters()">Mostrar Resultado</a>
  </div>
</div>